import { http } from "@/api/config.js";
import qs from "qs";

//cookie
let cookieList = document.cookie ? document.cookie.split(";") : [];
let cookies = {};
cookieList.forEach((item) => {
  if (!cookies[item.split("=")[0].trim()])
    cookies[item.split("=")[0].trim()] = item.split("=")[1];
});

//查询列表
// ◦ lower：分页索引下限
// ◦ upper：分页索引上限
// ◦ orderBy：排序键（注：需要使用数据库字段）
// ◦ userIdCon：用户编号（精确查询）
// ◦ examIdCon：考试编号（精确查询）
// ◦ clazzId：班级编号（精确查询）
// ◦ examTypeCon：考试类型（数字乘积）
// ◦ schoolIdCon：学校编号（精确查询）
// ◦ startTimeQB：开始时间下限，格式：YYYY-MM-DD hh:mm:ss
// ◦ startTimeQE：开始时间上限，格式：YYYY-MM-DD hh:mm:ss
// ◦ submitTimeQB：交卷时间下限，格式：YYYY-MM-DD hh:mm:ss
// ◦ submitTimeQE：交卷时间上限，格式：YYYY-MM-DD hh:mm:ss
// ◦ scoreTimeQB：评分时间下限，格式：YYYY-MM-DD hh:mm:ss
// ◦ scoreTimeQE：评分时间上限，格式：YYYY-MM-DD hh:mm:ss
// ◦ createTimeQB：创建时间下限，格式：YYYY-MM-DD hh:mm:ss
// ◦ createTimeQE：创建时间上限，格式：YYYY-MM-DD hh:mm:ss
export const GetExamListApi = (data) => {
  data.userIdCon = cookies["user-idcon"];
  for (let key in data) {
    if (data[key] === "") delete data[key];
  }
  return http({
    url: `/userExams/queries`,
    method: "POST",
    data: qs.stringify(data, { arrayFormat: "repeat" }),
  });
};
export const GetExamListCountApi = (data) => {
  data.userIdCon = cookies["user-idcon"];
  for (let key in data) {
    if (data[key] === "") delete data[key];
  }
  return http({
    url: `/userExams/count-queries`,
    method: "POST",
    data: qs.stringify(data, { arrayFormat: "repeat" }),
  });
};
export const SearchExamsApi = (data) => {
  for (let key in data) {
    if (data[key] === "") delete data[key];
  }
  data.original = 1;
  data.orderBy = "create_time DESC";
  return http({
    url: `/exams/queries`,
    method: "POST",
    data: qs.stringify(data, { arrayFormat: "repeat" }),
  });
};
